// import { createSlice } from "@reduxjs/toolkit";

// const storedUser = localStorage.getItem("user");
// const initialState = storedUser ? JSON.parse(storedUser) : null;

// const userSlice = createSlice({
//   name: "user",
//   initialState,
//   reducers: {
//     setUser: (state, action) => {
//       localStorage.setItem("user", JSON.stringify(action.payload));
//       return action.payload;
//     },
//     clearUser: () => {
//       localStorage.removeItem("user");
//       return null;
//     },
//   },
  
// });

// export const { setUser, clearUser } = userSlice.actions;
// export default userSlice.reducer;
import { createSlice } from "@reduxjs/toolkit";
const storedUser = localStorage.getItem("user");
const initialState = storedUser
  ? JSON.parse(storedUser)
  : {
      userType: null,
      fullName: "",
      username: "",
      email: "",
      phone: "",
      userId:"",
      chats:"",
      lastName:"",
      firstName:"",
      planName: "",
      orgName:"",
      name:""

    };

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const userData = {
        userType: action.payload.userType,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        username: action.payload.username,
        email: action.payload.email,
        phone: action.payload.phone,
        userId:action.payload.id,
        chats:action.payload.chats,
        orgName:action.payload.orgName,
        name:action.payload.name,
        // planName: action.payload.planName 
      };
      localStorage.setItem("user", JSON.stringify(userData)); 
      // console.log(userData,"userData")
      return {
        ...userData,
        planName: action.payload.planName, 
      };
    },
    clearUser: () => {
      localStorage.removeItem("user");
      return {
        userType: null,
        fullName: "",
        username: "",
        email: "",
        phone: "",
        userId:"",
        chats:"",
        lastName:"",
        firstName:"",
        planName: "",
        orgName:"",
        name:"",

      };
    },
  },
  
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
